<span (click)="openClaculater($event)" class="discount">+ {{ 'pages.createReceiptPage.oneReceipt.table.discountCalc.discount' | translate }}</span>
<div class="calculator" style="z-index:99999" *ngIf="opened">
  <div class="form-group">
    <label>{{ 'pages.createReceiptPage.oneReceipt.table.discountCalc.discountAmount' | translate }}</label>
    <div class="input-group">
      <span class="input-group-addon {{discountBy == '%'?'selected':''}}" (click)="makeDiscountBy('%')" id="basic-addon1">%</span>
      <span *ngIf="accountCurrencyCode; else byBranchCode" class="input-group-addon {{discountBy != '%'?'selected':''}}" (click)="makeDiscountBy(accountCurrencyCode)" id="basic-addon1">
        {{accountCurrencyCode}}
      </span>
      <ng-template #byBranchCode>
        <span class="input-group-addon {{discountBy != '%'?'selected':''}}" (click)="makeDiscountBy(branchCurrencyCode)" id="basic-addon1">
          {{branchCurrencyCode}}
        </span>
      </ng-template>
      <input [(ngModel)]="amount" type="text" class="form-control" placeholder="Discount amount" aria-describedby="basic-addon1">
    </div>
    <small>{{ 'pages.createReceiptPage.oneReceipt.table.discountCalc.maxDiscount' | translate }} : {{fixDecimals(discount) + discountBy}}</small>
  </div>
  <div class="form-group">
    <label>{{ 'common.comments' | translate }}</label>
    <span style="display: inherit;font-size: 12px;color: #dc291e;">{{requiredComment}}</span>
    <input type="text" class="form-control" placeholder="Comments" [(ngModel)]="discountComment" aria-describedby="basic-addon1">
  </div>
  <span>{{ 'pages.createReceiptPage.oneReceipt.table.discountCalc.RTDTotalAfterDiscount' | translate }} : <b>{{calculateDiscount()}}</b></span><br>
  <span>{{ 'pages.createReceiptPage.oneReceipt.table.discountCalc.totalAfterDiscount' | translate }} : <b>{{calculateTotalAfterDiscount()}}</b></span>
  <div class="armx-btn-group">
    <button class="btn btn-primary" (click)="applyDiscount()">
      {{ 'common.done' | translate }}
    </button>
    <button (click)="openClaculater($event)" class="btn btn-default">
      {{ 'common.cancel' | translate }}
    </button>
  </div>
</div>
